import styled from 'styled-components';
import { transparent, secondary, formGrey, medGrey, fontWeightHeavy, fontSizeSmaller, fontSizeSmall, quinary } from '../../../styles/styled/colors';

export const Wrapper = styled.div`
    background : ${props => props.fieldActive ? 'white' : transparent};
    border: 1px solid ${props => props.fieldActive ? formGrey : transparent};
    font-weight: ${fontWeightHeavy};
`;

export const Title = styled.label `
    padding-top: 5px;
    text-indent: 0.5rem;
    font-size: ${fontSizeSmaller};
    display: block;
    color: ${medGrey};
    margin-bottom: 0rem;
    text-transform: uppercase;
`;

export const TextInput = styled.input`
    text-indent: 0.5rem;
    width: 100%;
    border: none;
    outline: none;
    display: block;
    color: ${quinary};
    font-size: ${fontSizeSmall};
    background: transparent;
    border-bottom: 1px solid ${secondary};
    ::placeholder {
        color: ${medGrey};
        font-weight:300;
    }
`;


// WEBPACK FOOTER //
// ./src/components/common/Input/Styled.js